// Tiny client-side download helpers. No backend, no extra deps —
// every "Download" button in the AI home routes through here.

export function saveBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoke on the next tick — Safari needs the link alive briefly.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function saveText(text: string, filename: string, mime = "text/plain") {
  saveBlob(new Blob([text], { type: `${mime};charset=utf-8` }), filename);
}

export function saveJSON(value: unknown, filename: string) {
  saveText(JSON.stringify(value, null, 2), filename, "application/json");
}

/** Save a `data:` URL or remote http(s) image as a file. */
export async function saveImage(src: string, filename: string) {
  // data: URLs can be downloaded directly via an anchor.
  if (src.startsWith("data:")) {
    const a = document.createElement("a");
    a.href = src;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    return;
  }
  // Remote URL — fetch as blob so the browser actually saves it
  // instead of navigating to it.
  const res = await fetch(src);
  const blob = await res.blob();
  saveBlob(blob, filename);
}

/** Slugify a prompt into something safe for a filename. */
export function promptToFilename(prompt: string, max = 48): string {
  return (
    prompt
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, max) || "result"
  );
}